import styled from 'styled-components';
import { Link1 } from '@ui-library/typography';

export const ErrorViewContainer = styled.div`
  font-size: 20px;
`;

export const ErrorButton = styled(Link1)`
  color: #005ce6;
  font-size: 20px;
`;

export const VisualMappingContainer = styled.div`
  flex-direction: column;
  width: 100%;
  margin-top: 0px;
  align-items: center;
  display: flex;
`;

export const SourceDestSyncBehaviourContainer = styled.div`
  width: 475px;
`;

export const ConnectDestContainer = styled.div`
  flex-direction: column;
  width: 100%;
  margin-top: 0px;
  align-items: center;
  display: flex;

  .text-input__container {
    padding: 0;
    width: 475px;
    > :first-child {
      font-size: 0.875rem;
      color: #101836;
      display: block;
      margin-bottom: 0.375rem;
    }
    .ant-input-affix-wrapper {
      padding: 0 !important;
      width: 100%;
    }

    input {
      padding: 12px 16px;
      font-size: 14px;
      line-height: 20px;
      border-radius: 6px !important;
      background-color: ${({ theme }) => theme.token.colorBgContainer} !important;
      &:focus {
        outline: none;
        border: none !important;
      }
    }
  }
`;

export const NoFieldsColumnsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.token.colorBgContainer};
  margin-top: 40px;
`;

export const ReloadButtonsWrapper = styled.div`
  align-items: center;
  height: 100px;
  margin: auto;
  display: flex;
  flex-direction: row;
  width: 475px;
`;

export const ReloadFieldsWrapper = styled.span`
  margin-left: auto;
`;
